import React from "react";

import {
  Button,
  ButtonVariant,
} from "@patternfly/react-core";

import { LINKS } from "shared/config/links";
import { Icons } from "shared/components/Icons";

const SchoolEDziennikButton = ({ compact = false }) => {
  return (
    <Button
      variant={ButtonVariant.secondary}
      icon={compact ? Icons.BookIcon : undefined}
      component="a"
      href={LINKS.EDZIENNIK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={compact ? "E-Dziennik" : undefined}
      title={compact ? "E-Dziennik" : undefined}
    >
      {!compact && "E-Dziennik"}
    </Button>
  );
};

export default SchoolEDziennikButton;